import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { esFromEn, enFromEs } from "./dictionary";

export type Locale = "en" | "es";

export const SUPPORTED_LOCALES: Locale[] = ["en", "es"];

export const LOCALE_STORAGE_KEY = "cz_locale";

/** English phrases are used directly as translation keys. */
const esResources: Record<string, string> = { ...esFromEn };
const enResources: Record<string, string> = {};
for (const [en, es] of Object.entries(esFromEn)) enResources[en] = en;
for (const [es, en] of Object.entries(enFromEs)) {
  enResources[es] = en;
  esResources[es] = es;
}

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: enResources },
        es: { translation: esResources },
      },
      fallbackLng: "en",
      supportedLngs: SUPPORTED_LOCALES,
      nonExplicitSupportedLngs: true,
      load: "languageOnly",
      keySeparator: false,
      nsSeparator: false,
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator"],
        lookupLocalStorage: LOCALE_STORAGE_KEY,
        caches: ["localStorage"],
      },
      react: { useSuspense: false },
    });
}

export function normalizeLocale(value?: string | null): Locale {
  return value?.toLowerCase().startsWith("es") ? "es" : "en";
}

export function getActiveLocale(): Locale {
  return normalizeLocale(i18n.resolvedLanguage || i18n.language);
}

export default i18n;
